import { render, staticRenderFns } from "./CardWarningIcon.vue?vue&type=template&id=3512d2db&scoped=true&lang=pug"
import script from "./CardWarningIcon.vue?vue&type=script&lang=js"
export * from "./CardWarningIcon.vue?vue&type=script&lang=js"
import style0 from "./CardWarningIcon.vue?vue&type=style&index=0&id=3512d2db&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3512d2db",
  null
  
)

export default component.exports